import type { Card as CardType } from '../types/highlighted-card'

import { defineStore } from 'pinia'

import { ref } from 'vue'

export const useHighlightedCard = defineStore('highlightedCard', () => {
  const highlightedCard = ref<CardType>({
    type: 'none',
    id: '',
  })

  function setHighlightedCard(card: CardType): void {
    highlightedCard.value = card
  }

  function unsetHighlightedCard(): void {
    highlightedCard.value = {
      type: 'none',
      id: '',
    }
  }

  return {
    highlightedCard,
    setHighlightedCard,
    unsetHighlightedCard,
  }
})
